import { render } from "./ComboboxEmpty.vue?vue&type=template&id=2f27c9d8&ts=true"
import script from "./ComboboxEmpty.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComboboxEmpty.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/combobox/ComboboxEmpty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f27c9d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f27c9d8', __exports__)) {
    api.reload('2f27c9d8', __exports__)
  }
  
  module.hot.accept("./ComboboxEmpty.vue?vue&type=template&id=2f27c9d8&ts=true", () => {
    api.rerender('2f27c9d8', render)
  })

}


export default __exports__